import CheckIcon from '@atlaskit/icon/glyph/check';
import Lozenge from '@atlaskit/lozenge';
import { B300, B500, G400, N40, N500, N900 } from '@atlaskit/theme/colors';
import styled from '@emotion/styled';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export type FeatureMessageProps = {
  isLabelPresent?: boolean;
  message: string;
  modalTargetId?: string;
};

const FeatureMessage = ({
  isLabelPresent,
  message,
  modalTargetId
}: FeatureMessageProps) => {
  return (
    <>
      <FeatureMessageContainer>
        <CheckIcon size="medium" label="" primaryColor={G400} />
        {modalTargetId && (
          <button
            id={modalTargetId}
            onClick={(e) => {
              e.preventDefault();

              const modalTrigger: HTMLElement | null = document?.querySelector(
                `[data-target='#modal-${modalTargetId}']`
              );

              if (modalTrigger) {
                modalTrigger.click();
              } else {
                throw new Error(
                  `Feature modal trigger was not found for modal id: ${modalTargetId} with label "${message}"`
                );
              }
            }}
          >
            {message}
          </button>
        )}
        {!modalTargetId && (
          <MessageWithoutUnderline>{message}</MessageWithoutUnderline>
        )}
      </FeatureMessageContainer>
      {isLabelPresent && (
        <LabelContainer>
          <Lozenge style={{ backgroundColor: `${N40}`, color: `${N500}` }}>
            <Label>
              <FormattedMessage
                id="comingSoonLabel"
                defaultMessage="Coming Soon"
                description="Coming soon label"
              />
            </Label>
          </Lozenge>
        </LabelContainer>
      )}
    </>
  );
};

const FeatureMessageContainer = styled.div`
  display: flex;
  padding-left: 18px;
  padding-top: 16px;

  button {
    background: none;
    border: none;
    color: ${B300};
    cursor: pointer;
    font-family: 'Charlie Text';
    font-size: 16px;
    font-weight: 400;
    padding-left: 4px;
    text-align: left;
    text-decoration: underline;
    text-decoration-style: dashed;
    text-decoration-thickness: 1px;
    text-underline-offset: 3px;

    &:hover {
      color: ${B500};
    }
  }
`;

const MessageWithoutUnderline = styled.div`
  color: ${N900};
  padding-left: 4px;
`;

const Label = styled.div`
  border-radius: 4px;
  font-size: 11px;
  font-weight: normal;
  line-height: 16px;
  text-align: center;
  text-transform: uppercase;
`;

const LabelContainer = styled.div`
  padding-left: 46px;
`;

export { FeatureMessage };
